import noop from '@gaia/util/noop/action'
import index from './action/index'
import submit from './action/submit'

export default {
  index,
  submit,
  sent: noop,
}
